  
  const customerselectors = {
    clickElements: document.querySelectorAll('[data-clickelement]'),
    allRequired: document.querySelectorAll('[data-required]'),
    email: document.querySelector('#email'),
    emailconfirmation: document.querySelector('#emailconfirmation'),
    submitButton: document.querySelector('[data-form-submit]'),
    allFormControls: document.querySelectorAll('#customer_registration .form-control')
  };
  class customerInformationJS {
    constructor() {
        customerselectors.clickElements.forEach(element => {
            element.addEventListener('click', event => {
                this._checkForRequired(element);
                if(element.hasAttribute('data-next')){
                    if(!element.classList.contains('erroredForm')){
                        this._moveToNext(element);
                    }
                }
                if(element.hasAttribute('data-previous')){
                    this._moveToPrevious(element);
                }
            });
        })
        this._checkForKeyup();

        customerselectors.submitButton.addEventListener('click', event => {
            event.preventDefault();
            this._submitForm(event);
        })
    }

    _submitForm(event){
        let jsonObj = [];
        let item = {}

        let submitBtn = null;
        let checkForRequired = true
        if(event) {submitBtn = event.target;}
        if (submitBtn) {
            checkForRequired = this._checkForRequired(submitBtn);
            if (checkForRequired == false) {
                return false;
            }
            submitBtn.setAttribute("disabled", "true");
        }

        customerselectors.allFormControls.forEach(formControl =>{
            let id = formControl.getAttribute('id');
            let value = formControl.value;
            item[id] = value
        });
        jsonObj.push(item);
        const username = '2uz22w6rjwx3q8utphye8nyjc8j978p4';
        const password = '43bx9det0cd4nr5ypgmz9j3to2wd8tjh';

        const credentials = `${username}:${password}`;

        // Encode the credentials into base64
        const base64Credentials = btoa(credentials);

        fetch("https://shopifyapi.jinny.com:6443/api/CustomerApplication", {
            method: "POST",
            headers: {
                    'Authorization': `Basic ${base64Credentials}`,
                    "Content-Type": "application/json",
                    "Accept": "application/json",
                    "Access-Control-Allow-Origin": "*",
            },
            mode: 'cors',
            body: JSON.stringify(item),
            })
            // .then((response) => response.json())
            .then((data) => {
                document.querySelectorAll('#customer_registration input').forEach(input => {
                    input.value = '';
                });
                document.querySelectorAll('#customer_registration select').forEach(select => {
                    select.value = '';
                });
                if (data?.ok == false) {
                    window.notificationEle.updateNotification('Customer Submission', `Some error occured.`, {
                        type: 'error',
                        timeout: 5000
                      });
                } else {
                    window.notificationEle.updateNotification('Customer Submission', `Customer information submitted successfully.`, {
                        type: 'success',
                        timeout: 5000
                      });
                }

                  document.querySelector('[data-clickelement="step-1"]').dispatchEvent(new Event('click'));

                  if (submitBtn) {submitBtn.removeAttribute("disabled");}
                // fetch("https://shopifyapi.jinny.com:6443/api/CustomerApplication", {
                //     method: "GET",
                //     headers: {
                //             'Authorization': `Basic ${base64Credentials}`,
                //             "Content-Type": "application/json",
                //             "Accept": "application/json",
                //             "Access-Control-Allow-Origin": "*",
                //     },
                //     mode: 'cors',
                // }).
                // then(response => {
                //     return response.json();
                // }).then(response => {
                //     console.log('GET',response)
                // }).catch((e) => {
                //     console.error(e);
                // }).finally(() => {
                //     // Cart HTML fetch done
                // });
            })
            .catch((error) => {
              console.error('Error:', error);
              if (submitBtn) {submitBtn.removeAttribute("disabled");}
            //   Rollbar.error(`File: customer-information.js, getting error on _submitForm: ${error}`);
            });
    }

   

    _moveToPrevious(mainelement){
        let prevStep = mainelement.closest('[data-step]').getAttribute('data-step');
        mainelement.closest('[data-step]').classList.add('d-none');
        if(document.querySelector(`[data-step="${parseInt(prevStep) - 1}"]`)){
            document.querySelector(`[data-step="${parseInt(prevStep) - 1}"]`).classList.remove('d-none')
        }
        if(document.querySelector(`[data-step="${parseInt(prevStep) + 1}"]`)){
            document.querySelector(`[data-step="${parseInt(prevStep) + 1}"]`).classList.add('d-none')
        }
    }

    _moveToNext(mainelement){
        let nextStep = mainelement.closest('[data-step]').getAttribute('data-step');
        mainelement.closest('[data-step]').classList.add('d-none');
      
        if(document.querySelector(`[data-step="${parseInt(nextStep) + 1}"]`)){
            document.querySelector(`[data-step="${parseInt(nextStep) + 1}"]`).classList.remove('d-none')
        }
        if(document.querySelector(`[data-step="${parseInt(nextStep) + 2}"]`)){
            document.querySelector(`[data-step="${parseInt(nextStep) + 2}"]`).classList.add('d-none')
        }
    }

    _checkForKeyup(){
        customerselectors.allRequired.forEach(element => {
            element.addEventListener('keyup', event => {
                if(element.value == ''){
                    element.classList.add('errormsg');
                }else{
                    element.classList.remove('errormsg');
                }
                if(element.type == "email"){
                    if(!this.validateEmail(element.value)){
                        element.classList.add('errormsg');
                    }
                    if(document.querySelector('#emailconfirmation').value != document.querySelector('#email').value){
                        document.querySelector('#emailconfirmation').classList.add('errormsg');
                    }
                }
            })
        })
    }

    validateEmail(email){
        return email.match(
          /^(([^<>()[\]\\.,;:\s@\"]+(\.[^<>()[\]\\.,;:\s@\"]+)*)|(\".+\"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/
        );
    }

    _checkForRequired(mainelement){
        let flag = false;
        mainelement.closest('[data-step]').querySelectorAll('[data-required]').forEach(element => {
            if(element.value == ''){
                flag = true;
                element.classList.add('errormsg');
            }else{
                element.classList.remove('errormsg');
            }
            if(element.type == "email"){
                if(!this.validateEmail(element.value)){
                    flag = true;
                    element.classList.add('errormsg');
                }
            }
            if(flag == true){
                mainelement.classList.add('erroredForm')
            }else{
                mainelement.classList.remove('erroredForm')
            }
        });
        if(flag == true){
            return false;
        }else{
            return true;
        }
    }
  }
  
  typeof customerInformationJS !== 'undefined' && new customerInformationJS();
  